import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ImportService extends RestfulService<Models.Import> {

  constructor(private restService: RestService) {
    super(Models.Import);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('imports');
  }

}
